// Endpoints de SLA — `/v1/metricas/sla/*` (MET-04).
//
// ⚠️ `SlaPolicy` NÃO é semeada: sem política configurada, `adherenceRate` vem
// `null` nos dois alvos e todo caso cai em `noTarget`. Esse é o estado INICIAL de
// todo cliente, não caso de borda — a view precisa do empty state explícito.
import { api } from '@/lib/api';
import type { Drilldown, MetricsSlaAdherenceDto, WithEnvelope } from '../model';
import { metricsUrl, type MetricsListArgs, type MetricsSegmentArgs } from './shared';

export const metricsSlaApi = api.injectEndpoints({
  endpoints: (build) => ({
    metricsSlaAdherence: build.query<WithEnvelope<MetricsSlaAdherenceDto>, MetricsSegmentArgs>({
      query: (args) => metricsUrl('sla/aderencia', { ...args }),
      providesTags: ['MetricsAggregate'],
    }),
    metricsSlaViolations: build.query<WithEnvelope<Drilldown>, MetricsListArgs>({
      query: (args) => metricsUrl('sla/violacoes', { ...args }),
      providesTags: ['MetricsDrilldown'],
    }),
  }),
  overrideExisting: false,
});

export const { useMetricsSlaAdherenceQuery, useMetricsSlaViolationsQuery } = metricsSlaApi;
